// extracted by mini-css-extract-plugin
export default {"popup":"popup-cV_DVD_vHkZ7bOCfs2q7"};